const functions = require("../functions").default;

function getTarefaPipelinePadraoFiltroTemplate() {
    const el = document.getElementById("js-tarefa-pipeline-padrao-filtro-template-data");
    if (!el) {
        return null;
    }
    try {
        const parsed = JSON.parse(el.textContent || "null");
        if (parsed === null || parsed === "" || parsed === undefined) {
            return null;
        }
        return String(parsed);
    } catch (e) {
        return null;
    }
}

function getTarefaConfigHubIdsPorPipeline() {
    const el = document.getElementById("js-tarefa-config-hub-por-pipeline-data");
    if (!el) {
        return {};
    }
    try {
        return JSON.parse(el.textContent || "{}");
    } catch (e) {
        return {};
    }
}

function getTarefaFasesPorPipeline() {
    const el = document.getElementById("js-tarefa-fases-por-pipeline-data");
    if (!el) {
        return {};
    }
    try {
        return JSON.parse(el.textContent || "{}");
    } catch (e) {
        return {};
    }
}

function syncTarefaFaseSelect($form) {
    const $pipeline = $form.find(".js-tarefa-pipeline");
    const $fase = $form.find(".js-tarefa-fase");
    if (!$fase.length) {
        return;
    }
    const map = getTarefaFasesPorPipeline();
    const pipelineId = String($pipeline.val() || "");
    const selected =
        $fase.data("selected") ||
        $fase.attr("data-selected") ||
        $fase.val() ||
        "";
    $fase.find("option:not(:first)").remove();
    if (!pipelineId) {
        $fase.val("");
        return;
    }
    const fases = map[pipelineId] || map[Number(pipelineId)] || [];
    fases.forEach((fase) => {
        $fase.append(
            $("<option></option>").attr("value", fase.id).text(fase.value)
        );
    });
    if (selected && $fase.find(`option[value="${selected}"]`).length) {
        $fase.val(String(selected));
    }
    $fase.data("selected", null);
    $fase.attr("data-selected", "");
}

function syncTarefaTemplateSelect($form) {
    const $pipeline = $form.find(".js-tarefa-pipeline");
    const $select = $form.find(".js-tarefa-template, select[name='template_id']").first();
    if (!$select.length) {
        return;
    }
    const pipelineId = String($pipeline.val() || "");
    const pipelinePadrao = getTarefaPipelinePadraoFiltroTemplate();
    const pipelineFiltro = pipelineId || pipelinePadrao || "";
    const map = getTarefaConfigHubIdsPorPipeline();
    const allowed = pipelineFiltro
        ? map[pipelineFiltro] || map[Number(pipelineFiltro)] || []
        : null;
    const currentVal = $select.val();

    $select.find("option").each(function () {
        const $opt = $(this);
        if (!$opt.val()) {
            $opt.prop("disabled", false).prop("hidden", false);
            return;
        }
        if (allowed === null) {
            $opt.prop("disabled", false).prop("hidden", false);
            return;
        }
        const configId = Number($opt.attr("data-config-hub-id") || 0);
        const permitido = allowed.some((id) => Number(id) === configId);
        $opt.prop("disabled", !permitido).prop("hidden", !permitido);
    });

    if (
        currentVal &&
        !$select.find(`option[value="${currentVal}"]:not(:disabled)`).length
    ) {
        $select.val("");
    }
}

function syncWhatsappTarefaCampos($form) {
    const tipo = $form.find(".js-tipo-tarefa").val();
    const $box = $form.find(".js-div-mensagem-ativa");
    const tipoId = ($form.find(".js-tipo-tarefa").prop("id") || "").replace(
        "tipo",
        ""
    );
    const $template = $form.find(`#template_id${tipoId}, #template_id`).first();

    $box.addClass("d-none");
    $template.attr("required", false);

    if (tipo === "whatsapp") {
        $box.removeClass("d-none");
        $template.attr("required", true);
        syncTarefaFaseSelect($form);
        syncTarefaTemplateSelect($form);
    }
}

window.elocaSyncWhatsappTarefaCampos = syncWhatsappTarefaCampos;

export function uiEvents(context, isEmpty, aplicarMascaraTelefone) {
    $(".js-change-select", context).on("change", function () {
        if (this.value) {
            window.location.href = this.value;
        }
    });

    $(".js-custom-switch", context).on("change", function () {
        let bloco = $(this).closest(".js-checkbox-block").data("bloco");
        $(`.${bloco}`, context).toggleClass("d-none");
    });

    $(".js-copy-clipboard", context).on("click", function () {
        functions.copyTextToClipboard($(this).data("text"), this);
        $(this).html('<span class="text-success">Copiado!</span>');
    });

    $(".js-input-promocao", context).on("change keyup paste", function () {
        let value = this.value;
        $(".js-input-content.preco_promocao").text(value);
        if (value == null || value == "") {
            $(".js-input-content.preco").removeClass("promo");
        } else {
            $(".js-input-content.preco").addClass("promo");
        }
    });
    // Preview Texto
    $(".js-input-text", context).on("change keyup", function () {
        let field = $(this).closest(".form-group").data("input");
        $(`.js-input-content.${field}`).text(this.value);
    });
    // Resumo
    $(".js-textarea-text", context).on("change keyup paste", function () {
        $(".js-input-content.resumo").text(this.value);
    });
    // Faixas
    $(".js-exibicao-faixa", context).on("change", function () {
        $(".js-faixa-dropdown").toggleClass("d-none");
        $(".js-faixa-blocos").toggleClass("d-none");
    });
    // Estoque
    $(".js-select-option", context).on("change", function () {
        let status = this.value;
        if (status == 2) {
            $(".status_estoque.js-status-estoque").html(
                "<span class='text-danger'>Fora de Estoque</span>"
            );
        } else if (status == 3) {
            $(".status_estoque.js-status-estoque").html(
                "<span class='text-primary'>Sob consulta</span>"
            );
        } else {
            $(".status_estoque.js-status-estoque").html(
                "<span class='text-success'>Em estoque</span>"
            );
        }
    });

    // Modelo de Contrato
    $(".js-modelo-contrato-selecionado").on("change", function () {
        $(".js-btn-atualizar-modelo").removeClass("d-none");
    });

    // Menu customizado
    $(".js-select-tipo-menu", context).on("change", function (e) {
        let optionSelected = e.target.value;
        $(".js-option-menu").addClass("d-none");
        $(`.js-option-${optionSelected}`).removeClass("d-none");
    });

    function syncResultadoReuniao($form) {
        const tipo = $form.find(".js-tipo-tarefa").val();
        const concluida = $form.find(".js-tarefa-concluida").is(":checked");
        const $box = $form.find(".js-div-resultado-reuniao");
        const $select = $form.find(".js-resultado-reuniao");
        if (tipo === "reuniao" && concluida) {
            $box.removeClass("d-none");
            $select.attr("required", true);
            return;
        }
        $box.addClass("d-none");
        $select.attr("required", false);
    }

    $(".js-tipo-tarefa", context).on("change", function () {
        const $form = $(this).closest("form");
        syncWhatsappTarefaCampos($form);
        syncResultadoReuniao($form);
    });

    $(".js-tarefa-pipeline", context).on("change", function () {
        const $form = $(this).closest("form");
        syncTarefaFaseSelect($form);
        syncTarefaTemplateSelect($form);
    });

    $("form", context).each(function () {
        const $form = $(this);
        if ($form.find(".js-tarefa-fase").length) {
            syncWhatsappTarefaCampos($form);
        }
    });

    $(".js-tarefa-concluida", context).on("change", function () {
        syncResultadoReuniao($(this).closest("form"));
    });

    $(".js-mostrar-contratos-adicionais", context).on("change", function () {
        if ($(".js-mostrar-contratos-adicionais").is(":checked")) {
            $(".js-contratos-adicionais", context).removeClass("d-none");
        } else {
            $(".js-contratos-adicionais", context).addClass("d-none");
        }
    });

    $(".js-calculo-cobranca-adicional", context).on("change", function () {
        functions.calcChargeValue();
    });

    $(".js-color-picker", context).on("change", function () {
        let group = $(this).closest(".input-group");
        $(".js-color-text", group).val(this.value);
        $(".js-color-text", group).trigger("change");
    });
    $(".js-color-text", context).on("change", function () {
        let group = $(this).closest(".input-group");
        $(".js-color-picker", group).val(this.value);
    });

    $(".js-custom-radio-option", context).on("change", function () {
        let formCheck = $(this).closest(".js-form-check");
        $("div.card-selected", formCheck).removeClass("card-selected");
        $(this, formCheck)
            .closest(".checkout__radio")
            .addClass("card-selected");
    });

    $(".js-delete-image", context).on("click", function () {
        const name = $(this).data("name");
        const inputId = name.replace("[", "-").replace("]", "-");
        $(`#thumb-${inputId}`).attr("src", "");
        $(`#thumb-${inputId}`).closest("div").addClass("d-none");
        $(`#id-input-${inputId}`).val("");
    });

    $(".js-form-prevent-resend", context).on("submit", function () {
        $("#overlayer-loading").addClass("show-overlayer");
        $("button", this).attr("disabled", "disabled");
    });

    $("#js-select-lista-tipo", context).on("change", function () {
        $("#js-select-lista-tipo option").removeAttr("selected");
        $("#js-select-lista-tipo option[value='" + $(this).val() + "']").attr(
            "selected",
            "selected"
        );
        functions.displayCardTipo();
    });

    $(context).on("click", ".js-button-delete-item-lista", function () {
        var itemLista = $(this).parent().parent().parent().parent().parent();
        var itemListaClass = itemLista.attr("class");

        if (!isEmpty(itemListaClass)) {
            if (itemListaClass == "item-lista") {
                itemLista.remove();
            } else {
                showToastDanger(context, "Ocorreu um erro ao tentar excluir");
            }
        }
    });

    $(".js-adicionar-item-lista-tipo", context).on("click", function () {
        functions.adicionarNovoItemLista();
    });

    $(".js-fatura-avulsa-cartao", context).on("change", function () {
        if (this.value == "cartao") {
            $(".js-fatura-avulsa-parcelas", context).removeAttr("disabled");
        } else {
            $(".js-fatura-avulsa-parcelas", context).attr(
                "disabled",
                "disabled"
            );
        }
    });

    $(".js-habilita-token-contrato", context).on("change", function () {
        if (
            !$("#notificacao_sms").is(":checked") &&
            !$("#notificacao_whatsapp").is(":checked")
        ) {
            $("#notificacao_email").prop("checked", true);
        }
    });

    $(".js-busca-extrato-iugu").on("change", function () {
        const inicio = $("[name='inicio']").val();
        const buscar = $("[name='buscar']").val();
        const ano = $("[name='ano']").val();
        const mes = $("[name='mes']").val();
        const queryString = `?inicio=${inicio}&buscar=${buscar}&ano=${ano}&mes=${mes}`;
        const url = siteUrl(`/painel/extrato-iugu/exportar/${queryString}`);
        $("#linkExportExtrato").attr("href", url);
    });
    $(".js-busca-form-faturas-iugu").on("change", function () {
        const buscar = $("[name='buscar']").val();
        const ano = $("[name='ano']").val();
        const mes = $("[name='mes']").val();
        const status = $("[name='status']").val();
        const queryString = `?buscar=${buscar}&ano=${ano}&mes=${mes}&status=${status}`;
        const url = siteUrl(`/painel/extrato-iugu/exportar/${queryString}`);
        $("#linkExportFaturas").attr("href", url);
    });

    $(".js-form-filtro-oportunidades").on("change", function () {
        const periodo = $("[name='periodo']").val();
        const data_inicio = $("[name='data_inicio']").val();
        const data_fim = $("[name='data_fim']").val();
        const status = $("[name='status']").val();
        const pipeline_id = $("[name='pipeline_id']").val();
        const user_id = $("[name='user_id']").val();
        const nome = $("[name='nome']").val();
        const ativo_receptivo = $("[name='ativo_receptivo']").val();
        const tipo = $("[name='tipo']").val();
        const canal = $("[name='canal']").val();
        const tipo_atendimento_id = $("[name='tipo_atendimento_id']").val();
        const tipo_conteudo = $("[name='tipo_conteudo']").val();
        const motivo_perda_id = $("[name='motivo_perda_id']").val();
        const produto_id = $("[name='produto_id']").val();
        const fase_id = $("[name='fase_id']").val();
        const c_produtos = $("[name='c_produtos']").is(":checked") ? 1 : 0;
        const tags = $("[name='tags']").val();
        let tagsQuery = "";
        if (tags) {
            String(tags)
                .split(",")
                .map((tag) => tag.trim())
                .filter(Boolean)
                .forEach((tag) => {
                    tagsQuery += `&tags[]=${encodeURIComponent(tag)}`;
                });
        }

        const queryString = `?periodo=${periodo}&data_inicio=${data_inicio}&data_fim=${data_fim}&status=${status}&pipeline_id=${pipeline_id}&nome=${nome}&user_id=${user_id}&ativo_receptivo=${ativo_receptivo}&canal=${canal}&tipo=${tipo}&tipo_atendimento_id=${tipo_atendimento_id}&motivo_perda_id=${motivo_perda_id}&produto_id=${produto_id}&fase_id=${fase_id}&c_produtos=${c_produtos}&tipo_conteudo=${tipo_conteudo}${tagsQuery}`;
        const url = siteUrl(
            `/painel/fluxo-oportunidades/lista/exportar/${queryString}`
        );
        $("#linkExportReport").attr("href", url);
    });

    $(".js-form-filtro-tarefas").on("change", function () {
        const dono = $("[name='dono']").val();
        const situacao = $("[name='situacao']").val();
        const status = $("[name='status']").val();
        const pipeline_id = $("[name='pipeline_id']").val();
        const periodo_data_inicial = $("[name='periodo_data_inicial']").val();
        const periodo_data_final = $("[name='periodo_data_final']").val();
        const periodo = $("[name='periodo']").val();
        const queryString = `?dono=${dono}&situacao=${situacao}&status=${status}&pipeline_id=${pipeline_id}&periodo_data_final=${periodo_data_final}&periodo_data_inicial=${periodo_data_inicial}&periodo=${periodo}`;
        const url = siteUrl(
            `/painel/oportunidades-tarefas-exportar/${queryString}`
        );
        $("#linkExportReport").attr("href", url);
    });

    $(".js-form-filtro-pedidos").on("change", function () {
        const cliente = $("[name='cliente']").val();
        const id = $("[name='id']").val();
        const status_id = $("[name='status_id']").val();
        const isCupom = $("[name='isCupom']").is(":checked");
        const isCurenovacao_automaticapom = $(
            "[name='isCurenovacao_automaticapom']"
        ).val();
        const periodo_assinatura_pedido = $("[name='periodo_assinatura_pedido']").val();
        const periodo_data_inicial = $("[name='periodo_data_inicial']").val();
        const periodo_data_final = $("[name='periodo_data_final']").val();
        const tipo_pagamento_id = $("[name='tipo_pagamento_id']").val();
        const tipo_entrega_id = $("[name='tipo_entrega_id']").val();
        const estado_id = $("[name='estado_id']").val();
        const cidade_id = $("[name='cidade_id']").val();
        const ordem = $("[name='ordem']").val();
        const queryString = `?cliente=${cliente}&id=${id}&status_id=${status_id}&isCupom=${isCupom}&periodo_assinatura_pedido=${periodo_assinatura_pedido}&isCurenovacao_automaticapom=${isCurenovacao_automaticapom}&periodo_data_inicial=${periodo_data_inicial}&periodo_data_final=${periodo_data_final}&tipo_pagamento_id=${tipo_pagamento_id}&tipo_entrega_id=${tipo_entrega_id}&estado_id=${estado_id}&cidade_id=${cidade_id}&ordem=${ordem}`;
        const url = siteUrl(
            `/painel/pedidos/exportar-relatorio/${queryString}`
        );
        $("#linkExportReport").attr("href", url);
    });

    $(".js-form-filtro-produtos").on("change", function () {
        const nome = $("[name='nome']").val();
        const status_produto = $("[name='status_produto']").val();
        const status_estoque = $("[name='status_estoque']").val();
        const sku = $("[name='sku']").val();
        const ref_fornecedor = $("[name='ref_fornecedor']").val();
        const fora_de_portfolio = $("[name='fora_de_portfolio']").val();
        const order_field = $("[name='order_field']").val();
        const locais_retirada_id = $("[name='locais_retirada_id']").val();
        const display = $("[name='display']").val();
        const queryString = `?nome=${nome}&status_produto=${status_produto}&status_estoque=${status_estoque}&sku=${sku}&order_field=${order_field}&fora_de_portfolio=${fora_de_portfolio}&locais_retirada_id=${locais_retirada_id}&display=${display}&ref_fornecedor=${ref_fornecedor}`;
        const url = siteUrl(
            `/painel/pedidos/exportar-relatorio/${queryString}`
        );
        $("#linkExportReport").attr("href", url);
    });

    $(".js-busca-form-filtros-clientes").on("change", function () {
        const nome = $("[name='nome']").val();
        const email = $("[name='email']").val();
        const telefone1 = $("[name='telefone1']").val();
        const tag_id = $("[name='tag_id']").val();
        let data_inicio = $("[name='data_inicio']").val();
        data_inicio = data_inicio.replace("/", "%2F").replace("/", "%2F");
        let data_fim = $("[name='data_fim']").val();
        data_fim = data_fim.replace("/", "%2F").replace("/", "%2F");
        const carrinho = $("[name='carrinho']")[0].checked ? 1 : 0;
        const estado_id = $("[name='estado_id']").val();
        const cidade_id = $("[name='cidade_id']").val();

        const queryString = `?nome=${nome}&telefone1=${telefone1}&email=${email}&carrinho=${carrinho}&tag_id=${tag_id}&data_inicio=${data_inicio}&data_fim=${data_fim}&estado_id=${estado_id}&cidade_id=${cidade_id}`;
        const url = siteUrl(`/painel/clientes/exportar${queryString}`);
        $(".linkExportCliente").attr("href", url);
        console.log(url);
    });

    $(".js-busca-form-filtros-relatorio-assinatura").on("change", function () {
        const cliente = $("[name='cliente']").val();
        const id = $("[name='id']").val();
        const status_id = $("[name='status_id']").val();
        const status_entrega_id = $("[name='status_entrega_id']").val();
        const isCupom = $("[name='isCupom']")[0].checked ? 1 : 0;
        const produtos = $("[name='produtos']")[0].checked ? 1 : 0;
        const periodo_assinatura = $("[name='periodo_assinatura']").val();
        const periodo_data_inicial = $("[name='periodo_data_inicial']").val();
        const periodo_data_final = $("[name='periodo_data_final']").val();
        const plano = $("[name='plano']").val();
        const produto_id = $("[name='produto_id']").val();
        const queryString = `?cliente=${cliente}&id=${id}&status_id=${status_id}&status_entrega_id=${status_entrega_id}&isCupom=${isCupom}&produtos=${produtos}&periodo_assinatura=${periodo_assinatura}}&periodo_data_inicial=${periodo_data_inicial}&periodo_data_final=${periodo_data_final}&plano=${plano}&produto_id=${produto_id}`;
        const url = siteUrl(
            `/painel/relatorio-assinaturas/download-excel/${queryString}`
        );
        $("#assinaturas-exporta").attr("href", url);
    });

    $(".js-relatorio-assinatura-com-produto").on("change", function () {
        if (
            $(this).is(":checked") &&
            $(".js-buscar-produto-assinatura").hasClass("d-none")
        ) {
            $(".js-buscar-produto-assinatura").removeClass("d-none");
        }
        if (
            !$(this).is(":checked") &&
            !$(".js-buscar-produto-assinatura").hasClass("d-none")
        ) {
            $("[name='produto_busca']").val("");
            $("[name='produto_id']").val("");
            $(".js-buscar-produto-assinatura").addClass("d-none");
        }
    });

    function removerAcentos(texto) {
        return texto.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    }

    $(context).on("click", ".js-preencher-cadastro-cliente", function () {
        let data = window.dadosCadastroClienteCCL.data;
        let municipio = null;
        let uf = null;
        if (window.dadosCadastroClienteCCL.tipoPessoa == "pf") {
            $("input[name='rg']").val(data.RG);
            if (data.dataDeNascimento) {
                $("input[name='data_nascimento']").val(data.dataDeNascimento);
            }

            $("input[name='email']").val(data.email);
            $("input[name='bairro']").val(data.endereco.bairro);
            $("input[name='cep']").val(
                functions.preparaCepCCL(data.endereco.cep)
            );
            municipio = data.endereco.municipio;
            uf = data.endereco.uf;
            //$("select[name='cidade_id']").val(0);
            //$("select[name='estado_id']").val(0);
            $("input[name='complemento']").val(data.endereco.complemento);
            $("input[name='numero']").val(data.endereco.numero);
            $("input[name='rua']").val(data.endereco.logradouro);
            if (!$("input[name='telefone1']").prop("readonly")) {
                $("input[name='telefone1']").val(
                    aplicarMascaraTelefone(data.telefone)
                );
            }

            $("input[name='nome']").val(data.nome);

            $(".js-cliente-pj").hide();
            $(".js-cliente-pf").show();
        } else if (window.dadosCadastroClienteCCL.tipoPessoa == "pj") {
            let dataAbertura = data.dataDeAbertura;
            $("input[name='data_cadastro']").val(dataAbertura);
            $("input[name='email']").val(data.email);
            $("input[name='bairro']").val(data.bairroEmpresa);
            $("input[name='cep']").val(
                functions.preparaCepCCL(data.cepEmpresa)
            );
            municipio = data.cidadeEmpresa;
            uf = data.estadoEmpresa;
            //$("select[name='cidade_id']").val(0);
            //$("select[name='estado_id']").val(0);
            $("input[name='complemento']").val(data.complementoEmpresa);
            $("input[name='numero']").val(data.numeroEmpresa);
            $("input[name='rua']").val(data.ruaEmpresa);
            if (!$("input[name='telefone1']").prop("readonly")) {
                $("input[name='telefone1']").val(
                    aplicarMascaraTelefone(data.telefone)
                );
            }

            $("input[name='nome_fantasia']").val(data.nomeFantasia);
            $("input[name='razao_social']").val(data.razaoSocial);

            $(".js-cliente-pf").hide();
            $(".js-cliente-pj").show();
        }

        if (!isEmpty(uf)) {
            $("select[name='estado_id'] option")
                .filter(function () {
                    return $(this)
                        .text()
                        .toLowerCase()
                        .includes(uf.toLowerCase() + " -");
                })
                .prop("selected", true);

            $("select[name='estado_id']").trigger("change");

            if (!isEmpty(municipio)) {
                setTimeout(() => {
                    $("select[name='cidade_id'] option")
                        .filter(function () {
                            return removerAcentos(
                                $(this).text().toLowerCase()
                            ).includes(removerAcentos(municipio.toLowerCase()));
                        })
                        .prop("selected", true);
                }, 2000);
            }
        } else {
            functions.buscaCEP($("input[name='cep']").val(), context);
        }

        $("#modalAlertPainel").modal("toggle");
    });

    const syncPedidoLigacaoTemplate = function (dataId) {
        const cloud = dataId === 6;
        $(".js-campo-pedido-ligacao").toggleClass("d-none", !cloud);
        if (!cloud) {
            $(".js-pedido-ligacao").prop("checked", false);
        }
        const pedidoLigacao = $(".js-pedido-ligacao").is(":checked");
        $(".js-campo-templates-botoes").toggleClass("d-none", pedidoLigacao || (dataId !== 1 && dataId !== 6));
        $(".js-campo-template-imagem").toggleClass("d-none", pedidoLigacao || (dataId !== 1 && dataId !== 6));
    };

    $(".js-pedido-ligacao", context).on("change", function () {
        const dataId = Number($(".js-tipo-config-template").find(":selected").data("id"));
        syncPedidoLigacaoTemplate(dataId);
    });

    $(".js-tipo-config-template", context).on("change", function () {
        const dataId = Number($(this).find(":selected").data("id"));
        $(".js-campo-so-gupshup").each(function () {
            if (dataId === 1) {
                $(this).removeClass("d-none");
            } else {
                $(this).addClass("d-none");
            }
        });
        syncPedidoLigacaoTemplate(dataId);
        $(".js-campo-exc-gupshup").each(function () {
            if (dataId === 1) {
                $(this).removeClass("d-none");
            } else {
                $(this).addClass("d-none");
            }
        });
    });

    $(document).on("input", ".js-element-name-template", function () {
        let valor = removerAcentos($(this).val());
        valor = valor
            .toLowerCase()
            .trim()
            .replace(/ /g, "_")
            .replace(/[^a-z0-9_]/g, "")
            .replace(/_+/g, "_");
        $(this).val(valor);
    });
    
    $(".js-sumibt-meta", context).on("submit", function (evt) {
        let marcado = false;
        $('.js-pipeline-metas').each( function () {
            if ($(this).prop('checked')) {
                marcado = true;
            }
        });
        if (!marcado) {
            evt.preventDefault();  
            $("#overlayer-loading").removeClass("show-overlayer");
            $("button", context).removeAttr("disabled");
            $(".js-erro-form-meta").toggleClass("d-none");
            return
        }
    });
    $(document).on("click", ".js-texto-template", function () {
        const id = $(this).data("id");
        const container = $(`.js-texto-template-container-${id}`);
        $(container).toggleClass("text-truncate");
        if ($(container).hasClass("text-truncate")) {
           $(this).html("<i class='fas fa-plus'></i>");
        } else {
           $(this).html("<i class='fas fa-minus'></i>");
        }

    });

    function loadHyperflowTemplatesCard($card, explicitUrl) {
        const tbody = $card.find(".js-hyperflow-templates-tbody");
        const pagination = $card.find(".js-hyperflow-templates-pagination");
        let url = explicitUrl;

        if (!url) {
            const configId = $card.data("config-id");
            url = siteUrl(`/painel/config-hyperflow-templates/templates-por-config/${configId}`);
            const params = new URLSearchParams();
            const nome = $card.attr("data-nome");
            if (nome) {
                params.set("nome", nome);
            }
            const qsPage = new URLSearchParams(window.location.search);
            if (qsPage.has("order")) {
                params.set("order", qsPage.get("order"));
            }
            if (qsPage.has("order_field")) {
                params.set("order_field", qsPage.get("order_field"));
            }
            if (qsPage.has("config_id")) {
                params.set("config_id", qsPage.get("config_id"));
            }
            const qStr = params.toString();
            if (qStr.length) {
                url += (!url.includes("?") ? "?" : "&") + qStr;
            }
        }

        $.ajax({
            url,
            type: "GET",
            dataType: "json",
            headers: {
                Accept: "application/json",
                "X-Requested-With": "XMLHttpRequest",
            },
            success: function (resp) {
                tbody.html(resp.html_tbody || "");
                pagination.html(resp.html_pagination || "");
            },
            error: function () {
                tbody.html(
                    "<tr><td colspan=\"8\" class=\"text-center text-danger\">Não foi possível carregar os templates.</td></tr>"
                );
                pagination.empty();
            },
        });
    }

    $("[data-role=\"hyperflow-templates-card\"]", context).each(function () {
        loadHyperflowTemplatesCard($(this));
    });

    $(document).on(
        "click",
        ".js-hyperflow-templates-pagination a.page-link",
        function (e) {
            const $li = $(this).closest("li.page-item");
            if (
                $(this).attr("href") === "#"
                || $li.hasClass("disabled")
            ) {
                e.preventDefault();
                return;
            }
            const href = $(this).attr("href");
            if (!href) {
                e.preventDefault();
                return;
            }
            e.preventDefault();
            const $card = $(this).closest("[data-role=\"hyperflow-templates-card\"]");
            if (!$card.length) {
                return;
            }
            loadHyperflowTemplatesCard($card, href);
        },
    );

    $(".js-select-configs", context).on("change", function () {
        const configId = $(this).val();
        const container = $(".js-chat-historico-container", context);
        const clienteId = container.data("cliente-id");
        if (!configId || !clienteId) return;
        $("#overlayer-loading").addClass("show-overlayer");
        $.ajax({
            url: siteUrl(`/painel/clientes/chat-historico/${clienteId}/${configId}`),
            type: "get",
            success: function (res) {
                $("#overlayer-loading").removeClass("show-overlayer");
                container.html(res);
            },
            error: function () {
                $("#overlayer-loading").removeClass("show-overlayer");
            },
        });
    });

    $(".js-controlar-atribuicao-automatica", context).on("change", function () {
        if ($(this).is(":checked")) {
            $(".js-controlar-atribuicao-automatica-container", context).removeClass("d-none");
        } else {
            $(".js-controlar-atribuicao-automatica-container", context).addClass("d-none");
        }
    });

    $(".js-controlar-atribuicao-automatica-fora-horario", context).on("change", function () {
        if ($(this).is(":checked")) {
            $(".js-controlar-atribuicao-automatica-fora-horario-container", context).addClass("d-none");
        } else {
            $(".js-controlar-atribuicao-automatica-fora-horario-container", context).removeClass("d-none");
        }
    });

    $(".js-pipeline-alerta-atendente", context).on("change", function () {
        if ($(this).is(":checked")) {
            $(".js-pipeline-alerta-atendente-copiloto-container", context).removeClass("d-none");
            return;
        }
        $(".js-pipeline-alerta-atendente-copiloto-container", context).addClass("d-none");
        $(".js-pipeline-alerta-atendente-copiloto", context).prop("checked", false);
    });

}
